<template>
    <b-col md="12">
        <b-col md="12">
            <b-button v-b-tooltip.hover title="Wyświetl użyte produkty" @click="toggleShowIngredient()">
                <i class="fas fa-lg" :class="{ 'fa-arrow-up': showIngredient, 'fa-arrow-down': !showIngredient }"></i>
            </b-button>
        </b-col>
        <b-col md=12 v-show="showIngredient">
            <b-row>
                <b-col><b>Nazwa składnika</b></b-col>
                <b-col><b>Waga(kg)</b></b-col>
            </b-row>
            <b-row class="grid-table py-1" v-for="indigrient in indigrients" :key="indigrient.name">
                <b-col> {{ indigrient.name }}</b-col>
                <b-col>{{ indigrient.weight }}</b-col>
            </b-row>
        </b-col>
    </b-col>
</template>

<script>
export default {
    name: "DisplayCouverturesIngredients",
    props: ["indigrients"],
    methods: {
        toggleShowIngredient() {
            this.showIngredient = !this.showIngredient
        },
    },
    data() {
        return {
            showIngredient: false,
        }
    }
}
</script>